export const uk = {
    'empty-selected-screens': 'Не выбран ни один экран',
    'need-to-select-city': 'Необходимо выбрать город'
};
